import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonList, DropdownButton, DropdownButtonContext, } from '@dixa/lib-shared-habla';
import { Fragment } from 'react';
import { useSearchFilters } from '../../../../searchFilters.context';
/**
 * Represents a component that can be used to add, duplicate or remove
 * conditions for a filter
 */
export const ConditionActions = ({ index, condition, }) => {
    const { copyCondition, removeCondition } = useSearchFilters();
    const actions = [
        {
            text: 'Add another',
            icon: 'plus',
            actionFn: () => copyCondition(index, condition, { fullCopy: false }),
        },
        {
            text: 'Duplicate',
            icon: 'copy',
            actionFn: () => copyCondition(index, condition, { fullCopy: true }),
        },
        {
            text: 'Remove',
            icon: 'trash',
            divider: true,
            actionFn: () => removeCondition(index),
        },
    ];
    return (_jsx(DropdownButton, { icon: "dots-v", buttonProps: { variant: 'tertiary' }, fixed: true, noArrow: true, dropdown: _jsx(DropdownButtonContext.Consumer, { children: ({ toggleDropdown }) => (_jsx(ButtonList, { children: _jsx(ButtonList, { children: actions.map(({ text, icon, divider = false, actionFn }, index) => (_jsxs(Fragment, { children: [divider && _jsx(ButtonList.Divider, {}), _jsx(ButtonList.Item, Object.assign({ icon: icon, onClick: () => {
                                    actionFn();
                                    toggleDropdown();
                                } }, { children: text }))] }, index))) }) })) }) }));
};
